import { HalloweenArt } from "../theme/HalloweenArt";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { State } from "../reducer";
import { BannerBreak } from "./navbar/bannerBreak";
import BroadcastBanner from "./BroadcastBanner";
import { Props } from "../interfaces/layout";
import Sidebar, { MobileTopbar } from "./Sidebar";
import ThemeFx from "../theme/ThemeFx";

const SIDEBAR_OPEN_KEY = "woxa.sidebar.open";

const LayoutUnified = ({ children }: Props) => {
  const location = useLocation();
  const user = useSelector((state: State) => state.user);
  // Remember the user's last open/close choice across reloads. First-time
  // visitors get an open sidebar on tablet+ (desktop expects it) and a
  // closed one on phones (slide-in drawer is the mobile default).
  const [open, setOpen] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    try {
      const stored = window.localStorage.getItem(SIDEBAR_OPEN_KEY);
      if (stored != null) return stored === "1";
    } catch { /* private mode */ }
    return window.innerWidth >= 768;
  });
  useEffect(() => {
    try { window.localStorage.setItem(SIDEBAR_OPEN_KEY, open ? "1" : "0"); }
    catch { /* private mode */ }
  }, [open]);

  const isCloseRoute =
    location.pathname === "/close-all-admin" || location.pathname === "/close-all";

  // No sidebar on the public/full-bleed pages (login, close screens)
  const noChrome =
    !user?.role || isCloseRoute ||
    location.pathname === "/login" ||
    location.pathname === "/team-credit" ||
    location.pathname === "/order_bar";

  if (noChrome) {
    return (
      <>
        <ThemeFx />
        <main>
          {children}
          <Outlet />
        </main>
      </>
    );
  }

  return (
    <>
      <ThemeFx />
      <Sidebar open={open} onClose={() => setOpen(false)} />

      {/* Content area — always full-width. The sidebar overlays on top when
          open (instead of pushing content) so the layout doesn't reflow
          every toggle. */}
      <div className="min-h-screen bg-white">
        <MobileTopbar onOpen={() => setOpen(true)} />
        <BannerBreak />
        <BroadcastBanner />
        <div className="seasonal-shell-trim" aria-hidden="true"><HalloweenArt variant="cobweb" /><HalloweenArt variant="bats" /></div>
        <main>
          {children}
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default LayoutUnified;
